import { Button } from "antd";
import { useTranslation } from "react-i18next";

interface NewFileAttachmentsListProps {
  files: File[];
  themeColor: string;
  onRemoveFile: (index: number) => void;
}

export const NewFileAttachmentsList: React.FC<NewFileAttachmentsListProps> = ({
  files,
  themeColor,
  onRemoveFile,
}) => {
  const { t } = useTranslation();

  if (files.length === 0) {
    return null;
  }

  return (
    <ul className="mt-2 space-y-2">
      {files.map((file, idx) => (
        <li
          key={idx}
          className="flex items-center justify-between bg-gray-50 p-2 rounded border"
        >
          <span className="truncate max-w-[80%]" title={file.name}>
            {file.name}
          </span>
          <Button
            style={{ backgroundColor: themeColor }}
            danger
            type="text"
            size="small"
            onClick={() => onRemoveFile(idx)}
          >
            <span className="!p-0">{t("taskHub.modal.delete") || ""}</span>
          </Button>
        </li>
      ))}
    </ul>
  );
};
